import React from 'react'
import investor1 from "../assets/images/investor1.png";
import investor2 from "../assets/images/investor2.png";

function Invertors() {
    return (
        <div className='invertors'>
            <div className='container'>
                <div className='text-center'>
                    <h1 className='font-face-PlusJakartaSans-Bold px-2'>We are real estate investors with over    <span style={{ position: "relative", display: "inline-block", marginLeft: "8px" }}>
                        <span
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "40%",
                                backgroundColor: "#FFE500",
                                zIndex: -1,
                                marginTop: "20px",
                            }}
                        ></span>
                        2,000
                    </span> <span className='d-lg-block'>transactions of experience.</span></h1>
                </div>
                <div className='row mt-5 d-flex justify-content-center h-100'>
                    <div className='col-md-6 col-xl-4 px-3'>
                        <div className='box p-4'>
                            <div>
                                <img src={investor2} />
                            </div>
                            <h3 className='font-face-PlusJakartaSans-Bold'>Yousof Allam</h3>
                            <p className='font-face-PlusJakartaSans-Bold'>Yousof has over ten years of financial and investment experience in residential real estate as an investor and as a co-founder of a private equity firm that invested in over 2,000 scattered site single-family homes across multiple Texas markets.</p>
                            <p className='font-face-PlusJakartaSans-Regular'>With a background in oil and gas process technology with Weatherford International and British Petroleum, Yousof focuses creating efficient systems and processes to drive value at RealtyBase.</p>
                        </div>
                    </div>
                    <div className='col-md-6 col-xl-4 px-3 mt-4 mt-md-0'>
                        <div className='box p-4'>
                            <div>
                                <img src={investor1} />
                            </div>
                            <h3 className='font-face-PlusJakartaSans-Bold'>Ali Hasan</h3>
                            <p className='font-face-PlusJakartaSans-Bold'>Ali has more than ten years of experience in residential real estate, growing from buying and selling one single-family residence to co-founding and running a private equity firm that invested in over 2,000 scattered site single-family homes across multiple Texas markets.</p>
                            <p className='font-face-PlusJakartaSans-Regular'>As a natural born deal maker, Ali focuses on maintaining RealtyBase’s strong acquisition pipeline and maximizing dispositions</p>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    )
}

export default Invertors